var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58333 19.1667C4.29046 19.1667 0 14.8762 0 9.58333C0 4.29046 4.29046 0 9.58333 0C14.8762 0 19.1667 4.29046 19.1667 9.58333C19.1667 14.8762 14.8762 19.1667 9.58333 19.1667ZM8.45537 11.6342L5.80558 8.98246L4.79167 9.99637L7.78071 12.9873C7.96042 13.167 8.20413 13.2679 8.45825 13.2679C8.71237 13.2679 8.95608 13.167 9.13579 12.9873L14.8398 7.28525L13.822 6.2675L8.45537 11.6342Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.3973627f5957836c1207609674d362f7.svg";
export { ForwardRef as ReactComponent };